import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username } from '../internal.js'

const credentialTypes = [username, password, 'token'] as const
const locationCredentialTypes = ['customer-number'] as const

export type aactCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const aactDocumentTypes = [
  'inspection-certificate',
  'proof-of-delivery',
  'signed-bol',
  'invoice',
] as const satisfies readonly DocumentType[]

export const aact: CarrierDef<aactCredType> = {
  name: 'AAA Cooper',
  scac: 'aact',
  credentialTypes,
  locationCredentialTypes,
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'guaranteed', name: 'Guaranteed', guaranteed: true },
  ],
  legacyCredMap: [
    ['token', 'apiKey'],
    ['token', 'password'], // engine only and apiKey is set in engine so why do we have this?
    ['customer-number', 'ref1'],
  ],
  engineLayers: ['rating', 'pickup', 'profinder', 'documents', 'tracking'],
  documentTypes: aactDocumentTypes,
  credentialConfig: {
    'customer-number': { customerIdentifier: true },
  },
}
